import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import '@/scss/index.scss'
import day from '@/utils/dayjs'
import './global'
import { startTvAutoUpdate } from '@/utils/tvAutoUpdate'

Vue.config.productionTip = false
Vue.use(day)

new Vue({
  router,
  store,
  render: (h) => h(App)
}).$mount('#app')

startTvAutoUpdate()
